import { formatISO, parseISO,format} from 'date-fns';
import { enUS, ptBR, es } from 'date-fns/locale';
import { formatInTimeZone } from "date-fns-tz";

// Mapeamento dos locales do i18n para os da date-fns
const localesMap = {
    'en-US': enUS,
    'pt-BR': ptBR,
    'es-ES': es,
};

export function formatCategoriesDashboard(data, startDate, endDate, currentLocale, localeString) {
    if (!data) {
        return [];
    }
    const getDateParts = (isoStr) => {
        const [year, month, day] = isoStr.split('T')[0].split('-').map(Number);
        return { year, month, day };
    };

    const startParts = getDateParts(startDate);
    const endParts = getDateParts(endDate);

    // Compara apenas ano/mês/dia
    const sameDate =
        startParts.year === endParts.year &&
        startParts.month === endParts.month &&
        startParts.day === endParts.day;

    if (!sameDate) {
        return data.map(item => {
            const date = parseLocalDate(item.reference);
            const formatString = localeString === "en" ? "MMM d" : "d MMM";
            return format(date, formatString, { locale: currentLocale });
        });
    }

    // Se as datas forem iguais, formata por hora
    else {
        return data.map(item => {
            const gmtDateString = convertUtcToGmt(item.reference);

            // Cria Date a partir da string convertida
            const date = new Date(gmtDateString);

            // Escolhe formato de hora/dia conforme locale
            const formatString = localeString === 'en' ? 'h:mm a' : 'HH:mm';

            return format(date, formatString, { locale: currentLocale });
        });
    }
}

function parseLocalDate(dateString) {
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day); // esse já cria no fuso local sem shift
}

function convertUtcToGmt(dateString, gmtOffsetHours = 0) {
    let standardizedDateString = dateString;
    if (!dateString.endsWith('Z')) {
        standardizedDateString = dateString.replace(' ', 'T') + 'Z';
    }
    const utcDate = new Date(standardizedDateString);

    const gmtOffsetMinutes = gmtOffsetHours * 60;
    const targetGmtTime = utcDate.getTime() + (gmtOffsetMinutes * 60 * 1000);
    const targetGmtDate = new Date(targetGmtTime);
    const year = targetGmtDate.getUTCFullYear();
    const month = String(targetGmtDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(targetGmtDate.getUTCDate()).padStart(2, '0');
    const hours = String(targetGmtDate.getUTCHours()).padStart(2, '0');
    const minutes = String(targetGmtDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(targetGmtDate.getUTCSeconds()).padStart(2, '0');


    const offsetSign = gmtOffsetHours >= 0 ? '+' : '-';
    const absOffsetHours = Math.abs(gmtOffsetHours);
    const formattedOffsetHours = absOffsetHours.toString().padStart(2, '0');
    const formattedOffsetMinutes = '00'; // Assumindo offsets de hora cheia para simplificar

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${formattedOffsetHours}:${formattedOffsetMinutes}`;
}

// /utils/dateTimeFormat.js
export function formatDateByLocale(dateStr, locale) {
    if (!dateStr) return "";

    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    if (locale === "pt-BR" || locale === "es-ES") {
        return `${day}-${month}-${year}`;
    } else {
        return `${month}-${day}-${year}`;
    }
}

export function formatDateShortBR(dateStr) {
    if (!dateStr) return "-";

    const months = [
        "jan", "fev", "mar", "abr", "mai", "jun",
        "jul", "ago", "set", "out", "nov", "dez"
    ];

    const [day, month, year] = dateStr.split("/");

    const monthIndex = parseInt(month, 10) - 1;

    if (isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) {
        return dateStr; // fallback
    }

    return `${parseInt(day, 10)} de ${months[monthIndex]}`;
}

// Função de formatação para o v-date-input
export function dateFormatterInput(date, locale = "pt-BR") {
    if (
        !date ||
        date === "0000-00-00" ||
        date === "0000-00-00 00:00:00"
    ) {
        return "";
    }

    const hasTime = /\d{2}:\d{2}/.test(date);

    let timeZone = "UTC";

    if (locale === "pt-BR") {
        timeZone = "America/Sao_Paulo";
    } else if (locale === "es-ES") {
        timeZone = "Europe/Madrid";
    }

    const dateObj = new Date(date.endsWith("Z") ? date : date + "Z");

    if (locale === "en-US") {
        return formatInTimeZone(dateObj, timeZone, "yyyy-MM-dd");
    }

    const pattern = hasTime
        ? "dd/MM/yyyy HH:mm:ss"
        : "dd/MM/yyyy";

    let formatted = formatInTimeZone(dateObj, timeZone, pattern);

    if (locale === "pt-BR" && hasTime) {
        formatted = formatted.replace(" ", " às ");
    }

    return formatted;
}

export function formatDate(dateInput, format = "YYYY-MM-DD") {
    const date = new Date(dateInput);

    if (isNaN(date)) {
        throw new Error("Invalid Date");
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return format
        .replace("YYYY", year)
        .replace("MM", month)
        .replace("DD", day);
}
